/* eslint-disable no-use-before-define */
/* eslint-disable simple-import-sort/imports */
import React, { useEffect, useRef, useState } from 'react';
import ItemPage from '../Admin/Game/ItemPage';
import ItemAdd from '../Admin/Game/ItemAdd';
import ItemAddRestitution from '../Admin/Game/ItemAddRestitution';

type PageRestitution = {
  id: string;
  title: string | null;
  template_game: number;
  isNew?: boolean;
  [key: string]: any;
};

interface DragListRestitutionProps {
  initialItems: PageRestitution[];
  variableIndex: string | number;
  handleIndex?: (index: number) => void;
  handlePageToEdit?: (page: any, i?: number) => void;
  pageSelected?: any;
  handleReorderPages?: (items: PageRestitution[], newIndex: number) => void;
}

const DragListRestitution: React.FC<DragListRestitutionProps> = ({
  initialItems,
  variableIndex,
  handleIndex,
  handlePageToEdit,
  pageSelected,
  handleReorderPages,
}) => {
  const [items, setItems] = useState<PageRestitution[]>(initialItems);
  const dragItem = useRef<PageRestitution | null>(null);
  const dragOverItem = useRef<PageRestitution | null>(null);

  const handleDragStart = (e: React.DragEvent<HTMLDivElement>, item: PageRestitution) => {
    dragItem.current = item;
  };

  const handleDragEnter = (e: React.DragEvent<HTMLDivElement>, item: PageRestitution) => {
    dragOverItem.current = item;
  };

  const handleDragEnd = (e: React.DragEvent<HTMLDivElement>) => {
    const newList = [...items];
    const draggedItemContent = dragItem.current!;
    const dragOverItemContent = dragOverItem.current!;
    const dragItemIndex = items.findIndex(item => item.id === draggedItemContent.id);
    const dragOverItemIndex = items.findIndex(item => item.id === dragOverItemContent.id);

    newList.splice(dragItemIndex, 1);
    newList.splice(dragOverItemIndex, 0, draggedItemContent);

    setItems(newList);
    if (handleReorderPages) {
      handleReorderPages(newList, dragOverItemIndex);
    }
    dragItem.current = null;
    dragOverItem.current = null;
  };

  useEffect(() => {
    setItems(initialItems);
  }, [initialItems]);

  const renderListDrag = () => {
    let iterationNull = 0;
    return (
      <div>
        {items?.map((item, index) => {
          let iteration = 0;
          if (!item.title) {
            iteration = ++iterationNull;
          }
          return (
            <div
              key={item.id}
              draggable={true}
              onDragStart={e => handleDragStart(e, item)}
              onDragEnter={e => handleDragEnter(e, item)}
              onDragEnd={handleDragEnd}
              style={{ cursor: 'move' }}
              onClick={e => e.stopPropagation()}>
              <ItemAddRestitution variableIndex={variableIndex as string} position={index} />
              <ItemPage
                id={item.id}
                title={item.title ? item.title : `Page de restitution sans titre (${iteration})`}
                url=""
                isCover={false}
                nbPage={index + 1}
                isSelected={pageSelected?.id === item.id}
                handleClick={() => {
                  if (handlePageToEdit) handlePageToEdit(item, index);
                  if (handleIndex) handleIndex(index);
                }}
                isLastPage={items?.length === 1 ? true : index > 0 && items?.length === index + 1}
                isRestitution={true}
              />
            </div>
          );
        })}
      </div>
    );
  };

  return renderListDrag();
};

export default DragListRestitution;

